import { DropdownItem, Grid, Stack } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { FormSelectField, FormTextareaField, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { AdditionalServiceData, BusinessSegment, Service } from '@mews-commander/data-access';
import { DateTimeField } from '@mews-commander/form';
import { ServiceOrderFormField } from './schema';
import { TaxationFields } from './Fields/TaxationFields';

export const SettingsTab = ({
    service,
    businessSegments,
}: {
    service: Service;
    businessSegments?: BusinessSegment[] | null;
}) => {
    const { hasConfigurableBusinessSegment, orderRequiresCompletedNotes, orderRequiresSegment, hasOverridableTax } =
        service.options;

    return (
        <Stack vertical spacing="300">
            {!orderRequiresCompletedNotes && (
                <FormTextareaField label={lt(TextKey.Notes)} name={ServiceOrderFormField.Note} rows={1} />
            )}

            <DateTimeField required name={ServiceOrderFormField.StartUtc} label={lt(TextKey.Date)} inputSpacing="200" />

            <Grid templateColumns="1fr 1fr" rowGap="300">
                <TaxationFields
                    name={ServiceOrderFormField.TaxValues}
                    readOnly={!hasOverridableTax}
                    basePrice={(service.data.value as AdditionalServiceData).basePrice}
                />

                {service.defaultBusinessSegmentId || hasConfigurableBusinessSegment ? (
                    <FormSelectField
                        name={ServiceOrderFormField.SegmentId}
                        label={lt(TextKey.Segment)}
                        required={orderRequiresSegment}
                        readOnly={!hasConfigurableBusinessSegment}
                    >
                        <DropdownItem value="" label={UnicodeEntity.Dash} />
                        {businessSegments?.map((segment) => (
                            <DropdownItem key={segment.id} value={segment.id} label={segment.name} />
                        ))}
                    </FormSelectField>
                ) : null}
            </Grid>
        </Stack>
    );
};
